/* Fiche utensilios WOODMERA : remplace le runtime GemPages de woodsen.co (carrousels, accordeon, marquee,
   paliers du bundle, ajout au panier avec cadeau). Vanilla JS, aucune dependance. */
(function () {
  'use strict';
  if (window.__wdEsInit) return;
  window.__wdEsInit = true;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- carrousels (piste scroll-snap, fleches, miniatures) ---------- */
  function initCarousel(car) {
    var track = car.querySelector('.wd-es-track');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    var prev = car.querySelector('.wd-es-prev');
    var next = car.querySelector('.wd-es-next');
    function step() { var it = items[0]; if (!it) return track.clientWidth; var r = it.getBoundingClientRect(); var mr = parseFloat(getComputedStyle(it).marginRight) || 0; return r.width + mr; }
    function current() { var s = step(); return s ? Math.round(track.scrollLeft / s) : 0; }
    var raf;
    function goTo(i) {
      var s = step(); i = Math.max(0, Math.min(items.length - 1, i));
      /* animation maison sur scrollLeft, snap laisse en place : le smooth natif est annule par scroll-snap dans Chrome,
         et basculer scroll-snap-type fait revenir Chrome sur l'element snappe precedent */
      var from = track.scrollLeft, to = Math.round(i * s), t0 = null, dur = 380;
      if (raf) cancelAnimationFrame(raf);
      if (document.hidden || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { track.scrollLeft = to; return; }
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur); p = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = from + (to - from) * p;
        if (p < 1) raf = requestAnimationFrame(frame);
        else { track.scrollLeft = to; }
      }
      raf = requestAnimationFrame(frame);
    }
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); goTo(current() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); goTo(current() + 1); });
    car.__wdGoTo = goTo;
    car.__wdItems = items;
    /* points (mobile) */
    var dots = car.querySelector('.gp-carousel-dot-container');
    if (dots && car.hasAttribute('data-wd-dots')) {
      dots.innerHTML = '';
      items.forEach(function (_, i) { var b = document.createElement('button'); b.type = 'button'; b.className = 'wd-es-dot' + (i === 0 ? ' is-active' : ''); b.setAttribute('aria-label', 'Imagen ' + (i + 1)); b.addEventListener('click', function () { goTo(i); }); dots.appendChild(b); });
      track.addEventListener('scroll', function () { var c = current(); Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === c); }); }, { passive: true });
    }
    return { goTo: goTo, current: current, track: track, items: items };
  }

  function initGallery(wrap) {
    var feat = wrap.querySelector('gp-carousel-v3[type="gp-feature-image-carousel"]');
    var gal = wrap.querySelector('gp-carousel-v3[type="grid-carousel"]');
    var F = feat && initCarousel(feat);
    var G = gal && initCarousel(gal);
    if (!F) return;
    function setActive(i) {
      if (!G) return;
      G.items.forEach(function (t, k) { t.setAttribute('data-outline', k === i ? 'active' : 'deactive'); t.classList.toggle('active', k === i); });
      var s = G.items[i]; if (s) { var left = s.offsetLeft - G.track.offsetLeft; var vis = G.track.scrollLeft; if (left < vis || left + s.offsetWidth > vis + G.track.clientWidth) G.track.scrollTo({ left: left, behavior: 'smooth' }); }
    }
    if (G) G.items.forEach(function (t, i) { t.addEventListener('click', function () { F.goTo(i); setActive(i); }); });
    var tmr;
    F.track.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(function () { setActive(F.current()); }, 80); }, { passive: true });
    /* videos de la galerie : lecture quand visibles */
    F.items.forEach(function (it) { var v = it.querySelector('video'); if (v) { v.muted = true; v.playsInline = true; v.loop = true; } });
  }

  /* ---------- accordeon ---------- */
  function initAccordion(acc) {
    acc.querySelectorAll('.gp-accordion-item').forEach(function (item) {
      var head = item.querySelector('.gp-accordion-item_header');
      var body = item.querySelector('.gp-accordion-item_body');
      if (!head || !body) return;
      head.setAttribute('role', 'button'); head.setAttribute('tabindex', '0');
      function toggle() {
        var open = body.getAttribute('data-show') === 'true';
        body.setAttribute('data-show', open ? 'false' : 'true');
        body.style.gridTemplateRows = open ? '0fr' : '1fr';
        body.classList.toggle('gp-grid-rows-[0fr]', open);
        body.classList.toggle('gp-grid-rows-[1fr]', !open);
        item.classList.toggle('is-open', !open);
      }
      head.addEventListener('click', toggle);
      head.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------- marquee (react-fast-marquee sans React) ---------- */
  function initMarquee(mq) {
    var m = mq.querySelector('.rfm-marquee');
    var c = mq.querySelector('.rfm-initial-child-container');
    if (!m || !c) return;
    m.style.setProperty('--duration', '40s');
    m.style.setProperty('--play', 'running');
    /* v10 : animation en pause quand le defile est hors ecran (moins de couches composees pendant le scroll) */
    if ('IntersectionObserver' in window) { new IntersectionObserver(function (en) { m.style.setProperty('--play', en[0].isIntersecting ? 'running' : 'paused'); }, { rootMargin: '200px 0px' }).observe(mq); }
    if (!m.querySelector('.wd-es-marquee-clone')) {
      var clone = c.cloneNode(true); clone.classList.add('wd-es-marquee-clone'); clone.setAttribute('aria-hidden', 'true'); m.appendChild(clone);
    }
  }

  /* ---------- onglets (en-tete vide chez le concurrent : on le masque) ---------- */
  function initTabs(tab) {
    var ul = tab.querySelector('.gp-tab-header-list');
    if (ul && !ul.textContent.trim()) ul.style.display = 'none';
  }

  /* ---------- paliers du bundle + cadeau + compte a rebours ---------- */
  function initBundle(b) {
    var form = b.closest('form');
    var idInput = form && form.querySelector('input[name="id"]');
    var tiers = b.querySelectorAll('[data-wd-tier]');
    function select(t) {
      tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
      var r = t.querySelector('input[type="radio"]'); if (r) r.checked = true;
      if (idInput) idInput.value = r.value;
      b.setAttribute('data-gifts', t.getAttribute('data-gifts') || '');
      document.dispatchEvent(new CustomEvent('wd:variant', { detail: { id: r.value } }));
    }
    tiers.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });
    var sel = b.querySelector('[data-wd-tier].is-selected') || tiers[1] || tiers[0];
    if (sel) select(sel);
    /* compte a rebours (meme mecanique que Kaching : part de 18:02, se souvient dans la session) */
    var span = b.querySelector('[data-wd-timer]');
    if (span) {
      var key = 'wd-es-timer-end', end = 0;
      try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + (18 * 60 + 2) * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
      function tick() { var s = Math.max(0, Math.round((end - Date.now()) / 1000)); if (s === 0) { end = Date.now() + (18 * 60 + 2) * 1000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} } span.textContent = Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
      tick(); setInterval(tick, 1000);
    }
  }

  /* ---------- ajout au panier : set + soporte, puis notification Dawn ---------- */
  function initForm(form) {
    var btn = form.querySelector('button[name="add"]');
    var wrap = form.closest('.wd-es-form') || form;
    var err = wrap.querySelector('.product-form__error-message-wrapper');
    var errTxt = wrap.querySelector('.product-form__error-message');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var id = form.querySelector('input[name="id"]').value;
      var qty = parseInt((form.querySelector('input[name="quantity"]') || {}).value || '1', 10) || 1;
      var bundle = form.querySelector('.wd-bundle');
      var items = [{ id: id, quantity: qty }];
      var gifts = bundle ? (bundle.getAttribute('data-gifts') || '').split(',') : [];
      if (gifts.indexOf('h') > -1 && bundle.getAttribute('data-gift-variant')) items.push({ id: bundle.getAttribute('data-gift-variant'), quantity: 1 });
      if (gifts.indexOf('s') > -1 && bundle.getAttribute('data-surprise-variant')) items.push({ id: bundle.getAttribute('data-surprise-variant'), quantity: 1 });
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(','); body.sections_url = window.location.pathname; }
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('data-state', 'loading'); btn.classList.add('loading'); }
      if (err) err.hidden = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (resp) {
        if (resp.status) { if (err && errTxt) { errTxt.textContent = resp.description || resp.message || 'Das Produkt konnte nicht in den Warenkorb gelegt werden.'; err.hidden = false; } return; }
        if (cart && cart.renderContents) {
          if (resp.items && resp.items.length) { resp.key = resp.items[0].key; resp.id = resp.items[0].id; }
          try { cart.renderContents(resp); } catch (ex) { window.location.href = '/cart'; }
        } else { window.location.href = '/cart'; }
        document.dispatchEvent(new CustomEvent('wd:added', { detail: resp }));
      }).catch(function () { window.location.href = '/cart'; })
        .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.setAttribute('data-state', 'idle'); btn.classList.remove('loading'); } });
    });
  }

  /* ---------- barre d'achat collante ---------- */
  function initSticky(bar) {
    var hero = document.querySelector('.wd-es-form');
    if (!hero) return;
    function check() { var r = hero.getBoundingClientRect(); bar.classList.toggle('is-visible', r.bottom < 0); }
    window.addEventListener('scroll', check, { passive: true }); check();
    var go = bar.querySelector('[data-wd-sticky-go]');
    if (go) go.addEventListener('click', function (e) { e.preventDefault(); var t = document.querySelector('.wd-bundle') || hero; t.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    document.addEventListener('wd:variant', function (ev) { var p = bar.querySelector('[data-wd-sticky-price]'); var map = bar.getAttribute('data-prices'); if (p && map) { try { var m = JSON.parse(map); if (m[ev.detail.id]) p.innerHTML = m[ev.detail.id]; } catch (e) {} } });
  }

  /* ---------- v8 perf : videos chargees et lancees a l'approche du viewport, en pause hors ecran ---------- */
  function initLazyVideos() {
    var vids = document.querySelectorAll('video.wd-lazy-video'); if (!vids.length) return;
    function load(v) { if (v.__wdLoaded) return; v.__wdLoaded = true; v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); }); v.load(); }
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { load(v); play(v); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { load(v); play(v); } }); /* v10 : on ne met jamais en pause (iOS rend noir une video en pause hors ecran) */
    }, { rootMargin: '400px 0px' });
    vids.forEach(function (v) { io.observe(v); });
    /* repli par position (navigateurs integres, onglet rendu visible plus tard) : au defilement, tout ce qui est a moins de 400 px se charge */
    function check() { var H = window.innerHeight || 800; vids.forEach(function (v) { if (v.__wdLoaded) return; var r = v.getBoundingClientRect(); if (r.bottom > -400 && r.top < H + 400) { load(v); play(v); } }); }
    window.addEventListener('scroll', check, { passive: true }); window.addEventListener('resize', check, { passive: true });
    document.addEventListener('visibilitychange', check); window.__wdLazyCheck = check; check();
  }

  ready(function () {
    initLazyVideos();
    document.querySelectorAll('.wd-es-gallery').forEach(initGallery);
    document.querySelectorAll('gp-carousel-v3:not(.wd-es-gallery gp-carousel-v3)').forEach(function (c) { if (!c.closest('.wd-es-gallery')) initCarousel(c); });
    document.querySelectorAll('gp-accordion').forEach(initAccordion);
    document.querySelectorAll('gp-marquee').forEach(initMarquee);
    document.querySelectorAll('gp-tab').forEach(initTabs);
    document.querySelectorAll('.wd-bundle').forEach(initBundle);
    document.querySelectorAll('form[data-wd-form]').forEach(initForm);
    document.querySelectorAll('.wd-sticky').forEach(initSticky);
    /* "Lo quiero" (section 3) : defilement doux vers le bloc d'achat */
    document.querySelectorAll('a[href^="#gbzIfvDBRO"]').forEach(function (a) { a.addEventListener('click', function (e) { var t = document.querySelector('.wd-bundle') || document.getElementById('gbzIfvDBRO'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }); });
  });
})();
